import {
  Driver,
  MotorFunnelState,
  WireDrivers,
  WireDriver,
} from 'scenes/motor/types';
import { getAdditionalDrivers, getMainDriver } from 'scenes/motor/selectors';

const toYearsOfExperience = (value: number): string => {
  if (value < 0) return '';
  if (value === 0) return 'under 1';
  if (value >= 5) return '5 plus';

  return value.toString();
};

const toClaims = (value: number): string => {
  if (value < 0) return '';
  if (value === 0) return 'none';
  if (value >= 5) return '5 plus';

  return value.toString();
};

const mapDriver = (driver: Driver & { under25: boolean }): WireDriver => {
  const { gender, yearsDriving, claimsMade, payableClaims, under25 } = driver;
  return {
    gender,
    yearOfExperience: toYearsOfExperience(yearsDriving),
    claimNumber: toClaims(claimsMade),
    claimWithExcess: claimsMade >= 0 ? toClaims(payableClaims) : '',
    under25,
  };
};

export const toWireDriver = (state: MotorFunnelState): WireDrivers => ({
  ...mapDriver(getMainDriver(state)),
  additionalDrivers: getAdditionalDrivers(state).map((driver) =>
    mapDriver(driver)
  ),
});
